import React from "react";
import styled from "styled-components";
import {
  Form,
  DatePicker,
  Divider,
  Input,
  InputNumber,
  Button,
  Select
} from "antd";
const FormItem = Form.Item;
const Option = Select.Option;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AssessmentScoreForm extends React.PureComponent {
  handleSubmit = async e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        console.log("Received values of form: ", values);
        this.props.onSubmit("assessment", values);
      }
    });
  };

  _getScoreGroup = percentage => {
    if (percentage < 25) return "SCORE_GROUP_0";
    if (percentage < 60) return "SCORE_GROUP_1";
    if (percentage < 90) return "SCORE_GROUP_2";
    if (percentage <= 100) return "SCORE_GROUP_3";
  };

  _assessmentInputChange = fieldName => value => {
    // This isn't as tricky as it looks.
    // We take the this.props.form.getFieldsValue() method to fetch all the fields we need to generate the auto-generated assessment score fields. This returns an object. The object is one step behind the most recent changes (probably due to react state change not being syncronous while this callback is) thus we access the most recent change using "fieldName" and "value" and we overshadow the object provided to us from this.props.form.getFieldsValue() with {[fieldName]: value}. We then deconstruct and pull out the individual fields setting defaults for fields that may be undefined

    const {
      task1_score = 0,
      task2_score = 0,
      task3_score = 0,
      homework_score = 0
    } = Object.assign(
      this.props.form.getFieldsValue([
        "task1_score",
        "task2_score",
        "task3_score",
        "homework_score"
      ]),
      { [fieldName]: value }
    );

    const total_score =
      task1_score + task2_score + task3_score + homework_score;
    const percentage_score = (total_score / 50) * 100;
    const score_group = this._getScoreGroup(percentage_score);
    this.props.form.setFieldsValue({
      total_score,
      percentage_score,
      score_group
    });

    console.log("we changed", score_group);
  };

  componentDidMount() {
    // To disabled submit button at the beginning.
    this.props.form.validateFields();
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    return (
      <div>
        <Form onSubmit={e => this.handleSubmit(e)}>
          <Divider orientation="left">Assessment Score</Divider>
          <FormItem label="Task 1 Score (max. 15 marks)">
            {getFieldDecorator("task1_score")(
              <InputNumber
                initialValue={0}
                onChange={this._assessmentInputChange("task1_score")}
                min={0}
                max={15}
              />
            )}
          </FormItem>
          <FormItem label="Task 2 Score (max. 15 marks)">
            {getFieldDecorator("task2_score")(
              <InputNumber
                initialValue={0}
                onChange={this._assessmentInputChange("task2_score")}
                min={0}
                max={15}
              />
            )}
          </FormItem>
          <FormItem label="Task 3 Score (max. 10 marks)">
            {getFieldDecorator("task3_score")(
              <InputNumber
                initialValue={0}
                onChange={this._assessmentInputChange("task3_score")}
                min={0}
                max={10}
              />
            )}
          </FormItem>
          <FormItem label="Homework Score (max. 10 marks)">
            {getFieldDecorator("homework_score")(
              <InputNumber
                initialValue={0}
                onChange={this._assessmentInputChange("homework_score")}
                min={0}
                max={10}
              />
            )}
          </FormItem>
          <FormItem
            help="This is calculated automatically from the task scores and homework scores"
            label="Total Score Achieved (Total of 50 marks)"
          >
            {getFieldDecorator("total_score")(
              <InputNumber disabled min={0} max={50} />
            )}
          </FormItem>
          <FormItem
            help="This is calculated automatically from the task scores and homework scores"
            label="Percentage Score (%)"
          >
            {getFieldDecorator("percentage_score")(
              <InputNumber disabled min={0} max={100} />
            )}
          </FormItem>
          <FormItem
            help="This is calculated automatically from the task scores and homework scores"
            label="Score Group"
          >
            {getFieldDecorator("score_group")(<Input disabled />)}
          </FormItem>
          <FormItem>
            <Button
              type="primary"
              htmlType="submit"
              disabled={hasErrors(getFieldsError())}
            >
              Complete Section
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const WrappedAssessmentScoreForm = Form.create()(AssessmentScoreForm);

export default WrappedAssessmentScoreForm;
